module.exports = __webpack_public_path__ + "static/media/sosad.c52b0a3a.png";